// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconWithText__iconText___vEqaU {
    margin-left: 0.4em;
}

.IconWithText__iconMain___t5mCr {
    margin: 0.6em;
}

/* .ifDesktop {
    text-shadow: none;
    transition: 0.2s;
}

.ifDesktop:hover {
    text-shadow: 0px 0px 10px gold;
} */

.IconWithText__displayBlock___LLpER {
    display: block;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconText": `IconWithText__iconText___vEqaU`,
	"iconMain": `IconWithText__iconMain___t5mCr`,
	"displayBlock": `IconWithText__displayBlock___LLpER`
};
module.exports = ___CSS_LOADER_EXPORT___;
